function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
import styled from "styled-components";
import { Label } from "../";
export const PillDuration = ({
  topColor,
  bottomColor,
  label,
  duration = 0,
  ...props
}) => /*#__PURE__*/React.createElement(PillDurationContainer, _extends({
  yCenter: true,
  color: bottomColor
}, props), /*#__PURE__*/React.createElement(DurationBar, {
  color: topColor,
  duration: duration
}), /*#__PURE__*/React.createElement(DurationLabel, null, label));
const DurationLabel = styled(Label)`
  color: #ffffff;
  display: inline-block;
  font-size: 12px;
  font-weight: 600;
  line-height: 18px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  position: relative;
  text-align: center;
  width: 100%;
  z-index: 2;
`;
const PillDurationContainer = styled.div`
  background-color: ${props => props.color ? props.theme.palette[props.color].darker : props.theme.palette.black};
  border-radius: 24px;
  box-sizing: border-box;
  display: inline-block;
  height: 28px;
  overflow: hidden;
  padding: 5px 8px;
  position: relative;
  width: 86px;
  & + & {
    margin-left: 8px;
  }
`;
const DurationBar = styled.div.attrs(props => ({
  style: {
    width: `${props.duration}%`
  }
}))`
  background-color: ${props => props.theme.palette[props.color ? props.color : "teal"].primary};
  box-sizing: border-box;
  display: inline-block;
  height: 28px;
  position: absolute;
  left: 0;
  top: 0;
`;